import {defineMessages, FormattedMessage} from 'react-intl';
import {Action, Icon, view} from '@sail/ui';
import {chevronRight} from '@sail/icons/react/Icon';
import type {IconAsset} from '@sail/icons/types';
import {Badge, Text} from 'src/v2/components/common';
import {COLORS} from 'src/v2/util/color';

const messages = defineMessages({
  installed: {
    id: 'crypto.payins.v2.wallet_select.installed',
    description: 'A badge to signal that the wallet is installed',
    defaultMessage: 'Installed',
  },
});

type Props = {
  title: string;
  icon: IconAsset;
  onClick: () => void;
};

export const BrowserExtensionSelect = ({title, icon, onClick}: Props) => {
  return (
    <Action onPress={onClick}>
      <view.div
        css={{
          stack: 'x',
          paddingY: 'medium',
          backgroundColor: COLORS.offsetOnLight,
          borderRadius: 'small',
          padding: 'space.150',
          alignItems: 'center',
          distribute: 'space-between',
          ':hover': {
            backgroundColor: COLORS.offsetHoverOnLight,
          },
        }}
      >
        <view.div
          css={{
            stack: 'x',
            gapX: 'small',
            justifyContent: 'start',
            alignItems: 'center',
          }}
        >
          <Icon icon={icon} size="large" css={{borderRadius: 'small'}} />
          <Text type="bodyEmphasized">{title}</Text>
        </view.div>

        <view.div css={{stack: 'x', gap: 'small'}}>
          <Badge>
            <Text type="captionEmphasized" css={{color: 'inherit'}}>
              <FormattedMessage {...messages.installed} />
            </Text>
          </Badge>
          <Icon icon={chevronRight} size="xsmall" />
        </view.div>
      </view.div>
    </Action>
  );
};
